/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/merchant/types";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_SortingState,
  MaterialReactTable,
} from "material-react-table";
import TableActions from "../../../common/table/TableActions";

export interface Props {
  merchant: Data[];
  merchantCount: number;
  pagination: MRT_PaginationState;
  setPagination: (values: MRT_PaginationState) => void;
}

interface RowData {
  id: string;
  name?: string;
  mid?: string;
}

export class MerchantTableParams {
  page = 0;
  pageSize = 10;
  pageCount = 0;
  orderBy = -1;
  orderDirection = "";
  searchText = "";
  searchField = "attributes.Name";
  totalCount = 1;
  cache?: string = 'ignore';
}

export const ColumnToRecordMapping = [
  "id",
  "attributes.Name",
  "attributes.MID",
];

const mapDataToTable = (merchant: Data[]): RowData[] => {
  return merchant.map((data) => {
    return {
      id: data.id,
      name: data.attributes.Name,
      mid: data.attributes.MID,
    };
  });
};

export default function MerchantTable({
  merchant,
  merchantCount,
  pagination,
  setPagination,
}: Props) {
  const history = useHistory();
  const [sorting, setSorting] = useState<MRT_SortingState>([]);

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "mid",
        header: "MID",
      },
    ],
    []
  );

  const editAction = (rowData: RowData) => {
    history.push(`/merchant/edit/${rowData.id}`);
  };

  const viewAction = (rowData: RowData) => {
    history.push(`/merchant/view/${rowData.id}`);
  };

  return (
    <MaterialReactTable
      columns={columns}
      data={mapDataToTable(merchant)}
      getRowId={(row) => row.id}
      initialState={{ showColumnFilters: false, density: "spacious" }}
      enableTopToolbar={false}
      enableColumnFilters={false}
      enableColumnActions={false}
      manualFiltering
      manualPagination
      onPaginationChange={setPagination}
      onSortingChange={setSorting}
      rowCount={merchantCount}
      muiTablePaginationProps={{
        rowsPerPageOptions: [10],
      }}
      state={{
        pagination,
        sorting,
      }}
      enableRowActions
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Merchant"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
